type DRoute<T> = {
  [P in keyof T]: T[P] extends object
    ? {
        path: string;
        fullPath: string;
      } & DRoute<T[P]>
    : {
        path: string;
        fullPath: string;
      };
};

// Transformation function
export function compileRoutes<T>(
  input: T,
  currentPath: string[] = []
): DRoute<T> {
  const output: any = {};

  for (const key in input) {
    const newPath = [...currentPath, key];
    const isObject = typeof input[key] === 'object';

    output[key] = {
      path: key,
      fullPath: '/' + newPath.join('/'),
    };

    if (isObject) {
      Object.assign(output[key], compileRoutes(input[key], newPath));
    }
  }

  return output;
}
